import { useEffect, useState } from "react";
import { ReceiptText, Store } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api, inr } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function SalesmanSales() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/salesman/my-sales").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="my-sales-page">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold flex items-center gap-2"><ReceiptText className="text-emerald-600" /> My Sales</h1>
        <button data-testid="salesman-new-bill" onClick={() => nav("/admin/pos")} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-bold text-sm flex items-center gap-2"><Store size={16} /> New Bill</button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Stat label="Today Bills" value={data?.today_count ?? "—"} />
        <Stat label="Today Sales" value={data ? inr(data.today_total) : "—"} accent />
        <Stat label="Total Bills" value={data?.count ?? "—"} />
        <Stat label="Total Sales" value={data ? inr(data.total) : "—"} accent />
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead><tr className="text-xs font-bold uppercase tracking-wider text-slate-500 bg-slate-50">
            <th className="text-left py-3 px-4">Bill</th><th className="text-left py-3 px-4">Customer</th><th className="text-left py-3 px-4">Total</th><th className="text-left py-3 px-4">Status</th></tr></thead>
          <tbody>{(data?.orders || []).map((o) => (
            <tr key={o.id} data-testid={`my-sale-${o.id}`} className="border-b border-slate-50 hover:bg-slate-50">
              <td className="py-2.5 px-4"><p className="font-semibold">{o.order_no}</p><p className="text-xs text-slate-400">{new Date(o.created_at).toLocaleDateString("en-IN")}</p></td>
              <td className="py-2.5 px-4">{o.customer_name || "Walk-in"}</td>
              <td className="py-2.5 px-4 font-semibold">{inr(o.total)}</td>
              <td className="py-2.5 px-4"><StatusBadge status={o.status} /></td>
            </tr>
          ))}
          {data && !data.orders.length && <tr><td colSpan="4" className="text-center py-12 text-slate-400">Abhi tak koi bill nahi banaya.</td></tr>}</tbody>
        </table>
      </div>
    </div>
  );
}
const Stat = ({ label, value, accent }) => <div className="bg-white rounded-xl border border-slate-200 p-3.5"><p className="text-[11px] font-semibold text-slate-500 uppercase">{label}</p><p className={`text-xl font-extrabold mt-0.5 ${accent ? "text-emerald-600" : "text-slate-900"}`}>{value}</p></div>;
